/** User-facing strings: monitoring. */
export const monitoring = {
    title: "Monitoring",
    description: "Agents of the organisation {name}.",
    unavailableTitle: "Monitoring is unavailable",
    unavailableText: "The agents could not be read. Nothing was changed. Retry in a few seconds.",
    retry: "Retry",
    emptyTitle: "No agents to monitor",
    emptyText: "Once an agent is enrolled, its uptime and connections appear here.",
    downloadAgent: "Download the agent",
    agentsAndServers: "Agents & Servers",
    footnote:
        "Uptime is the share of time an agent was connected to the relay, from its connect and disconnect history (the last 50 events of each agent, at most 7 days). The status and connections are live; uptime and the 24-hour line are as of the last refresh.",
    refresh: "Refresh",
    list: {
        agents: "Agents",
        agentsScrollable: "Agents, scrollable",
        caption: "Status, uptime, connections and last seen of each agent",
        agent: "Agent",
        status: "Status",
        uptime24h: "Uptime 24 h",
        uptime7d: "Uptime 7 d",
        connectionsNow: "Connections now",
        lastSeen: "Last seen",
        last24Hours: "Last 24 hours",
        partial: "(partial)",
        partialHint:
            "The relay keeps the last 50 connects and disconnects of an agent. This share covers the time since the oldest of them.",
        statusUnavailable: "Status unavailable",
        now: "now",
        never: "never",
    },
    uptime: {
        underOnePercent: "<{percent}",
        sparklineNone: "No connection data for the last 24 hours",
        sparkline: "Connected {uptime} of the last 24 hours, {count, plural, one {# disconnect} other {# disconnects}}",
    },
};
